<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="relative flmid">
                <div class="flgrow">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="pService.searchTerm" autocomplete="off" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary">
                                <em class="fa fa-search"></em>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 0">
            <app-dealer-searchbox-dropdown [dealerList]="dealerList"  [selectedDealer]="selectedDealer" ngDefaultControl name="dealerDropdown" (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
            </app-dealer-searchbox-dropdown>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6">
            <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus" 
            (change)="StatusChange($event)">
                <ng-option *ngFor="let status of StatusList" [value]="status.id" >
                    {{status.value}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
            <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary" translate>lblAddMechanic</button>
        </div>
    </div>
</div>
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex">
                    <h4 class="card-title" translate>lblMechanic</h4>

                </div>
                <div class="table-responsive">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">Id</th>
                                <th scope="col" sortable="name" (sort)="onSort($event)" translate>lblName</th>
                                <th style="width: 15%" scope="col" translate>lblADEmail</th>
                                <th style="width: 19%" scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName</th>
                                <th style="width: 22%" scope="col" sortable="employeeNo" (sort)="onSort($event)" translate>lblEmployeeNumber</th>
                                <th style="width: 22%" scope="col" *ngIf="!areCodesHidden" translate>lblDealershipsId</th>
                                <th style="width: 22%" scope="col" *ngIf="!areCodesHidden" translate>lblFunctionCode</th>
                                <th style="width: 19%" scope="col" sortable="activeStatus" (sort)="onSort($event)" translate>lblActive</th>
                                <th style="width:50px" class="text-center" scope="col" sortable="dmsSyncDate" (sort)="onSort($event)"  
                                    *ngIf="isOLB" translate>lbllastSyncdate</th>
                                <th style="width: 75px" class="text-center" scope="col" (sort)="onSort($event)" translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="mechanicList?.length>0; else load_else">
                                <tr *ngFor="let mechanic of mechanicList; let i=index">
                                    <td>{{ mechanic.rowNumber }}</td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.name" [term]="pService.searchTerm"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.adEmail" [term]="pService.searchTerm"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.dealerName" [term]="pService.searchTerm"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.employeeNo" [term]="pService.searchTerm"></ngb-highlight>
                                    </td>
                                    <td *ngIf="!areCodesHidden">
                                        <span *ngIf="mechanic.locationCode">{{mechanic.locationCode}} - {{mechanic.locationName}}</span>
                                    </td>
                                    <td *ngIf="!areCodesHidden">
                                        <span *ngIf="mechanic.functionCode">{{mechanic.functionCode}} - {{mechanic.functionCodeDescription}}</span>
                                    </td>
                                    <td>
                                        <em class="fas"
                                          [ngClass]="{'fa-check': mechanic.isActive, 'fa-times cursordisable': !mechanic.isActive}"></em>
                                      </td>
                                      <td class="text-center" *ngIf="isOLB">
                                          {{ mechanic.dmsSyncDate | date:'short'}}
                                      </td>
                                    <td class="nowrap text-center">
                                        <ng-container *ngIf="isOLB">
                                            <a class="btn btn-ico"
                                                ngbTooltip="{{ 'lblSyncToOLB' | translate }}"
                                                tooltipClass="custom-revert"
                                                [class.invisible]="mechanic.dmsSyncStatus === true"
                                                (click)="onSyncToDms(mechanic.id)">
                                                <em class="fas fa-sync fa-lg  "></em>
                                            </a>
                                            <span class="ico-div"
                                                [class.invisible]="mechanic.dmsSyncStatus === true"></span>
                                            <a class="btn btn-ico"
                                                ngbTooltip="{{ 'lblOLBSyncFailedlog' | translate }}"
                                                tooltipClass="custom-revert"
                                                [class.invisible]="mechanic.dmsSyncStatus === true"
                                                (click)="viewException(mechanic.employeeNo)">
                                                <em class="fas fa-clipboard-list fa-lg  "></em>
                                            </a>
                                            <span class="ico-div"
                                                [class.invisible]="mechanic.dmsSyncStatus === true"></span>
                                        </ng-container>
                                        <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(mechanic)" *ngIf="userRoleRightsDetails.canEdit">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>

                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>

                </div>
                <div class="card-footer">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-between">
                            <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page" [pageSize]="pService.pageSize" [maxSize]="3">
                            </ngb-pagination>
                            <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
                        </div>
                        <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                            <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>

</div>